
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 18","data-token-name":"sms-document"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 17v-3a1 1 0 112 0 1 1 0 012 0v3m4-4h-1.25c-.199 0-.39.105-.53.293A1.19 1.19 0 0014 14c0 .265.079.52.22.707.14.188.331.293.53.293h.5c.199 0 .39.105.53.293.141.187.22.442.22.707 0 .265-.079.52-.22.707-.14.188-.331.293-.53.293H14m-8-4H4.75c-.199 0-.39.105-.53.293A1.19 1.19 0 004 14c0 .265.079.52.22.707.14.188.331.293.53.293h.5c.199 0 .39.105.53.293.141.187.22.442.22.707 0 .265-.079.52-.22.707-.14.188-.331.293-.53.293H4m9.666-15.5H3.848c-.578 0-1.133.225-1.542.625-.41.4-.64.943-.64 1.508v12.8m2.182-11.91h4.91m-4.91 2.485h4.91M3.848 9.5h2.444","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.03 11.1v-8c0-.424.173-.831.48-1.131.306-.3.723-.469 1.157-.469.434 0 .85.169 1.157.469.307.3.479.707.479 1.131v1.067H12.03","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    